import { CartAddEvent } from '@theme/events';

// Persistent timer with localStorage and cart change detection
const TIMER_KEY = 'cart_timer_start';
const CART_COUNT_KEY = 'cart_count_last';


// Add CSS to hide timer placeholders initially
const style = document.createElement('style');
style.textContent = `
  .cart-banner__content[data-timer-text*="[timer-"] {
    visibility: hidden;
  }
  .cart-banner__content.timer-ready {
    visibility: visible !important;
  }
`;
document.head.appendChild(style);

function getTimerStart() {
  const stored = localStorage.getItem(TIMER_KEY);
  if (!stored) {
    const now = Date.now();
    localStorage.setItem(TIMER_KEY, now.toString());
    return now;
  }
  const timestamp = parseInt(stored);
  return timestamp;
}

function resetTimer() {
  const now = Date.now();
  localStorage.setItem(TIMER_KEY, now.toString());
  return now;
}

function getCartCount() {
  const cartBubble = document.querySelector('.cart-bubble__text-count');
  const cartItemCount = document.querySelector('[ref="cartItemCount"]');
  
  if (cartBubble && cartBubble.textContent.trim()) {
    return parseInt(cartBubble.textContent.trim()) || 0;
  }
  if (cartItemCount && cartItemCount.textContent.trim()) {
    return parseInt(cartItemCount.textContent.trim()) || 0;
  }
  return 0;
}

function checkCartChanges() {
  const currentCount = getCartCount();
  const lastCount = parseInt(localStorage.getItem(CART_COUNT_KEY) || '0');
  
  // Reset timer if cart becomes empty or items are added
  if ((currentCount === 0 && lastCount > 0) || (currentCount > lastCount)) {
    resetTimer();
  }
  
  localStorage.setItem(CART_COUNT_KEY, currentCount.toString());
}

function updateTimer() {
  const banner = document.querySelector('.cart-banner__content');
  if (!banner || !banner.dataset.timerText) return;
  
  const timerStart = getTimerStart();
  const elapsed = Math.floor((Date.now() - timerStart) / 1000);
  
  
  // Replace all [timer-X] patterns with countdown
  const updatedText = banner.dataset.timerText.replace(/\[timer-(\d+)\]/g, (match, minutes) => {
    const totalSeconds = parseInt(minutes) * 60;
    const remaining = totalSeconds - (elapsed % totalSeconds);
    const mins = Math.floor(remaining / 60);
    const secs = remaining % 60;
    const timeString = `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    return timeString;
  });
  
  banner.innerHTML = updatedText;
  
  // Show the banner now that timer is processed
  banner.classList.add('timer-ready');
}

// Listen for cart add events to reset timer
document.addEventListener('DOMContentLoaded', () => {
  let timerInterval = null;
  let isCartOpen = false;
  
  
  // Reset timer when items are added to cart
  document.addEventListener('cart:add', () => {
    resetTimer();
  });
  
  // Also listen for the theme's CartAddEvent
  document.addEventListener('CartAddEvent', () => {
    resetTimer();
  });
  
  function startTimer() {
    isCartOpen = true;
    
    if (timerInterval) return; // Already running
    
    // Start the timer interval that runs continuously
    timerInterval = setInterval(() => {
      // Only update the display when cart is open
      if (isCartOpen) {
        updateTimer();
      }
      // Timer continues running in background even when cart is closed
    }, 1000);
    
    updateTimer(); // Update immediately
  }

  function stopTimer() {
    isCartOpen = false;
    // Don't clear the interval - let it continue running in background
  }

  new MutationObserver(() => {
    const cartOpen = document.querySelector('.cart-drawer__dialog[open]');
    
    if (cartOpen && !isCartOpen) {
      startTimer();
    } else if (!cartOpen && isCartOpen) {
      stopTimer();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
});
